/**
 * @generated SignedSource<<1d2c552c086b10b1b30546bb458b73c7>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type DeleteEmailTemplateInput = {
  id: string;
};
export type DeleteEmailTemplateDialogMutation$variables = {
  input: DeleteEmailTemplateInput;
};
export type DeleteEmailTemplateDialogMutation$data = {
  readonly deleteEmailTemplate: {
    readonly id: string;
  };
};
export type DeleteEmailTemplateDialogMutation = {
  response: DeleteEmailTemplateDialogMutation$data;
  variables: DeleteEmailTemplateDialogMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "IdPayload",
    "kind": "LinkedField",
    "name": "deleteEmailTemplate",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "DeleteEmailTemplateDialogMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "DeleteEmailTemplateDialogMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "fd24614fe59127f3627961d1cbc5ccfc",
    "id": null,
    "metadata": {},
    "name": "DeleteEmailTemplateDialogMutation",
    "operationKind": "mutation",
    "text": "mutation DeleteEmailTemplateDialogMutation(\n  $input: DeleteEmailTemplateInput!\n) {\n  deleteEmailTemplate(input: $input) {\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "cf5f5c2bae8dec279774282ceed57481";

export default node;
